module.exports = __webpack_public_path__ + "img/logo_Korea_University-300x150.7c6afb77.png";